import { BehaviorSubject, Observable} from "rxjs";
import { Injectable} from "@angular/core";
import { StripeAccountSessionResponse } from "../model/stripe-account-session-response";
import { RestaurantFinancialStatusResponse } from "../model/restaurant-financial-status-response";

@Injectable({
    providedIn: 'root',
})
export class RestaurantFinanceStateService {

    private sessionState$: BehaviorSubject<StripeAccountSessionResponse> = new BehaviorSubject<StripeAccountSessionResponse>(new StripeAccountSessionResponse());
    private financialState$: BehaviorSubject<RestaurantFinancialStatusResponse> = new BehaviorSubject<RestaurantFinancialStatusResponse>(new RestaurantFinancialStatusResponse());

    constructor(
    ) {
    }

    public getSessionData$(): Observable<StripeAccountSessionResponse> {
        return this.sessionState$.asObservable();
    }

    public getSessionData(): StripeAccountSessionResponse {
        return this.sessionState$.getValue();
    }

    public setSessionData(value: StripeAccountSessionResponse): void {
        this.sessionState$.next(value);
    }

    public getFinancialData$(): Observable<RestaurantFinancialStatusResponse> {
        return this.financialState$.asObservable();
    }

    public getFinancialData(): RestaurantFinancialStatusResponse {
        return this.financialState$.getValue();
    }

    public setFinancialData(value: RestaurantFinancialStatusResponse): void {
        this.financialState$.next(value);
    }
}
